import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import TaskCompletionStepDetails from '../../containers/TasksContainer/MobileTaskDetails/TaskCompletionStepDetails';
import MobileSpinner from '../../components/MobileSpinner';
import MobileHeader from '../../components//MobileHeader';
import { getCompletionStepUserPermissions } from '../../helpers/permissions/CompletionStepPermissionsUtil';
import mobileBridge from '../../helpers/MobileBridge';
import FileUtil from '../../helpers/FileUtil/FileUtil';
import AttachmentHelper from '../../helpers/AttachmentHelper';
import DataSource from '../../dao/DataSource/DataSource';

import './TaskCompletionStepDetailWrapper.scss';
import '../MobileWrapper.scss';

const taskDescriptor = {
  task: {
    completion_criteria: {
      attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
      comments: { user: { additionalFields: ['profile_image'] } },
      event_histories: {},
    },
    reference_documents: {},
    user_task_assignments: {
      user: {
        additionalFields: ['profile_image'],
        companies: {},
      },
    },
    inventory_items: { inventory: {} },
    event_histories: {},
    project: { },
  },
};

const completionStepDescriptor = {
  completion_criteria: {
    attachments: {
      additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'],
      conversions: {},
    }, 
    comments: {
      user: { },
    },
    event_histories: {},
  },
};
  
class TaskCompletionStepDetailWrapper extends BasePage {
  constructor(props) {
    super(props);
    
    this.state = {
      isInitialized: false,
      userStepPermissions: new Set(),
      selectedFile: null,
    };
    this.isBuildOwner = false;
    this.isProjectManager = false;

    this.determineUserStepPermissions = this.determineUserStepPermissions.bind(this);
  }

  handleCompletionStepRetrieval(completionStep, action, acData) {
    this.setState({ completionStep });
    this.determineUserStepPermissions(this.state.task, completionStep);
  }

  handleTaskRetrieval(task, action, acData) {
    if (task.build_owners && task.build_owners.filter(bowner => { return bowner.id == this.props.currentUser.id; }).length) {
      this.isBuildOwner = true;
    }
    if (
      this.props.currentUser.role.name == 'editor' ||
      this.props.currentUser.role.name == 'admin' ||
      (task.project && task.project.project_manager_id == this.props.currentUser.id)
    ) {
      this.isProjectManager = true;
    }
    if (this.completionStepDataSource) {
      this.completionStepDataSource.get();
    }
    this.setState({ task });
  }

  handleSetupTaskDataSource() {
    const { task_id } = this.props.match.params;
    if (this.taskDataSource) {
      this.taskDataSource.release();
    }
    this.taskDataSource = new DataSource('Task', task_id, taskDescriptor, this.handleTaskRetrieval);
    this.taskDataSource.get();
  }

  handleSetupCompletionStepDataSource() {
    const { completion_step_id } = this.props.match.params;
    if (this.completionStepDataSource) {
      this.completionStepDataSource.release();
    }
    this.completionStepDataSource = new DataSource('CompletionCriterion', completion_step_id, completionStepDescriptor, this.handleCompletionStepRetrieval);
  }

  componentDidMount() {
    const { completion_step_id, task_id } = this.props.match.params;
    mobileBridge.initialize(this.props.history);
    if (completion_step_id && task_id) {
      this.handleSetupTaskDataSource();
      this.handleSetupCompletionStepDataSource();
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
    if (this.completionStepDataSource) {
      this.completionStepDataSource.release();
      this.completionStepDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    const prevParams = prevProps.match ? prevProps.match.params : {};
    const nextParams = this.props.match ? this.props.match.params : {};
    if ((nextParams && prevParams && prevParams.task_id != nextParams.task_id) ||
      prevProps.navigateUri != this.props.navigateUri) {
      this.handleSetupTaskDataSource();
      this.handleSetupCompletionStepDataSource();
    }
    else if ((nextParams && prevParams && prevParams.completion_step_id != nextParams.completion_step_id) ||
      prevProps.navigateUri != this.props.navigateUri) {
      this.handleSetupCompletionStepDataSource();
      this.completionStepDataSource.get();
    }
  }

  async handleChildCompletionStepUpdate(completionStep) {
    this.completionStepDataSource.set(completionStep);
  }

  determineUserStepPermissions(task, completionStep) {
    const {
      currentCompany,
      currentUser,
      isBuildOwner,
    } = this.props;
    
    const stepPermissions = getCompletionStepUserPermissions({
      currentCompany,
      currentUser,
      isBuildOwner,
      project: task.project,
      task,
      view: completionStep ? 'completionStep' : 'tasks',
      completionStep,
      isVendor: currentUser && currentCompany &&
        currentUser.companies && currentUser.companies.length > 0 && currentCompany.id != currentUser.companies[0].id,
    });

    this.setState({ userStepPermissions: stepPermissions });
  }

  handleFileSelected(file) {
    this.setState({ fileSelected: file });
  }

  handleFileClose() {
    this.setState({ fileSelected: null });
  }

  createFileDisplay() {
    const { fileSelected } = this.state;

    let ext = FileUtil.getExtension(fileSelected.name);
    const isImage = FileUtil.extensionTypes.photoTypes.includes(ext);

    return (
      <div className='ref-doc'>
        {isImage
          ? <img className="display-ref-doc" src={fileSelected.upload} alt={'Reference Doc'} />
          : AttachmentHelper.getConvertedDocumentView(fileSelected)
        }
      </div>
    );
  }

  render() {
    // TODO: is this necessary?
    if (!this.props.currentUser || !this.props.currentCompany) {
      return null;
    }

    this.setWhiteLabels(this.props.currentCompany);
    let { completionStep } = this.state;

    if (!this.state.task || !this.state.completionStep) {
      return (
        <div className="mobile-wrapper">
          <MobileHeader headerTitle={'Completion Step'}
            rootPage={false}
            hasOfflineChanges={completionStep && completionStep._dirty ? true : false}
            displayHandsFree={true}
          />
          <MobileSpinner />
        </div>
      );
    }

    let content;

    if (this.state.fileSelected) {
      content = this.createFileDisplay();
    }
    else {
      content = (
        <TaskCompletionStepDetails
          completionStep={completionStep}
          task={this.state.task}
          action={this.props.match.params ? this.props.match.params.action : null}
          userStepPermissions={this.state.userStepPermissions}
          isBuildOwner={this.isBuildOwner}
          isProjectManager={this.isProjectManager}
          handleChildCompletionStepUpdate={this.handleChildCompletionStepUpdate}
          handleFileSelected={this.handleFileSelected}
        />
      );
    }
    const isFileSelected = !!(this.state.fileSelected);
    return (
      <div className="mobile-wrapper">
        {this.props.systemPopup}
        <MobileHeader
          headerTitle={'Completion Step'}
          rootPage={false}
          hasOfflineChanges={completionStep && completionStep._dirty ? true : false}
          useDoneButton={isFileSelected}
          navigateBack={isFileSelected ? this.handleFileClose : null}
          displayHandsFree={true}
        />
        <div className="content-wrapper step-detail-wrapper">
      
          {content}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    systemPopup: state.main.systemPopup,
    navigateUri: state.main.navigateUri,
  };
};

export default withRouter(connect(mapStateToProps)(TaskCompletionStepDetailWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/TaskCompletionStepDetailWrapper/index.js